module.exports = __webpack_public_path__ + "img/img_logo_posco_mexico_blue.f26ac56d.png";